// A single index is shared by the chat stream, thread list, and message actions.
export function indexDiscussion(comments) {
  const byId = new Map(comments.map(comment => [comment.id, comment]));
  const roots = new Map();
  function rootOf(comment) {
    if (!comment) return undefined;
    if (roots.has(comment.id)) return roots.get(comment.id);
    const path = [], seen = new Set();
    let current = comment;
    while (current.parentId && byId.has(current.parentId) && !roots.has(current.id)) {
      if (seen.has(current.id)) return comment; // Malformed cycles never hang the UI.
      seen.add(current.id);
      path.push(current);
      current = byId.get(current.parentId);
    }
    const root = roots.get(current.id) || current;
    roots.set(current.id, root);
    for (const item of path) roots.set(item.id, root);
    return root;
  }
  const threads = new Map();
  for (const comment of comments) {
    const root = rootOf(comment);
    if (!threads.has(root.id)) threads.set(root.id, []);
    threads.get(root.id).push(comment);
  }
  const chronological = (a, b) => a.createdAt.localeCompare(b.createdAt);
  for (const messages of threads.values()) messages.sort(chronological);
  const chat = comments.filter(comment => comment.chat && !comment.parentId).sort(chronological);
  const topics = comments.filter(comment => !comment.parentId && (!comment.chat || threads.get(comment.id).length > 1)).map(root => {
    const messages = threads.get(root.id);
    const replies = messages.filter(message => message.id !== root.id && !message.deletedAt);
    const latestReply = replies.at(-1);
    return {root, count: replies.length, latest: latestReply?.createdAt || root.createdAt, latestReply};
  }).sort((a, b) => b.latest.localeCompare(a.latest));
  return {byId, threads, chat, topics, rootOf};
}

export function rootFor(comment, comments) {
  const byId = new Map(comments.map(item => [item.id, item]));
  let current = comment;
  const seen = new Set();
  while (current?.parentId && !seen.has(current.id)) {
    seen.add(current.id);
    current = byId.get(current.parentId) || current;
  }
  return current;
}
